import Image, { StaticImageData } from "next/image";
import styled from "styled-components";

const Card = styled.div`
   /* max-width: 24rem; */
   border-radius: 0.5rem;
   overflow: hidden;
   box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
   background-color: #e6f2ff;
   padding: 2.5rem;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   @media screen and (min-width: 768px) {
      padding: 3rem;
   }
`;

const CardContent = styled.div`
   position: relative;
`;

const Title = styled.h2`
   font-weight: 700;
   font-family: "Millik";
   font-size: 24px;
   margin-bottom: 0.5rem;
   max-width: 100px;
   color: #2d3748;
`;

const Number = styled.div`
   position: absolute;
   font-family: "Millik";
   top: 0rem;
   right: 0rem;
   background-color: #fff;
   border-radius: 9999px;
   width: 4rem;
   height: 4rem;
   font-size: 24px;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   font-weight: 700;
`;

const List = styled.ul`
   color: #3e3d3d;
   font-size: 16px;
   padding-left: 1rem;
   list-style-type: disc;
   @media screen and (min-width: 768px) {
      font-size: 14px;
   }
   /* list-style-position: inside; */
`;

const ListItem = styled.li`
   margin-bottom: 0.5rem;
`;

const ImageContainer = styled.div`
   position: relative;
   height: 18rem;
   width: 100%;
   border-radius: 0.5rem;
   /* padding: 1.5rem; */
`;

const Divider_SC = styled.div`
   margin: 1rem 0;
   height: 1px;
   width: 100%;
   /* padding: 0rem !important; */

   background-color: #66666633;
`;

export interface IInfoCard {
   number: string;
   title: string;
   items: string[];
   image: StaticImageData;
   bgColor: string;
   imageAlt: string;
}

export const InfoCard = ({ number, title, items, image, bgColor, imageAlt }: IInfoCard) => {
   return (
      <Card style={{ backgroundColor: bgColor }}>
         <CardContent>
            <Title>{title}</Title>
            <Number>{number}</Number>
            <Divider_SC />
            <List>
               {items.map((el, i) => (
                  <ListItem key={i}>{el}</ListItem>
               ))}
            </List>
         </CardContent>
         <ImageContainer>
            <Image
               src={image}
               alt={imageAlt}
               layout="fill"
               objectFit="cover"
               style={{ borderRadius: "0.5rem" }}
            />
         </ImageContainer>
      </Card>
   );
};
